export default {
  "gnav.event.title": "Events",
  "gnav.event.subTitle": "Events",
  "gnav.event.eventsMain": "LINK-J Events/LINK-J Supported Events",
  "gnav.event.memberEvent": "Special Member Events",
  "gnav.event.coSponsorship": "Co-sponsorship",
  "gnav.event.eventsAttend": "Exhibitions",
  "gnav.event.archive": "Past Events",
  "gnav.eventReport.title": "Event Reports",
  "gnav.eventReport.main": "LINK-J Events/LINK-J Supported Events",
  "gnav.eventReport.memberEvent": "Special Member Events",
  "gnav.eventReport.coSponsorship": "Co-sponsorship",
  "gnav.eventReport.attend": "Exhibitions",
  "gnav.programs.title": "Programs",
  "gnav.programs.consultation": "Out of Box Consulting Room",
  "gnav.programs.program": "Training Programs",
  "gnav.programs.MedtechProgram_LINK": "",
  "gnav.programs.sandbox": "",
  "gnav.programs.unikorn": "",
  "gnav.programs.linkBiobay": `What's "LINK-BioBAY TOKYO"？`,
  "gnav.interview.title": "Interviews & Blogs",
  "gnav.interview.subTitle": "Interviews & Blogs",
  "gnav.interview.special-interviews": "",
  "gnav.interview.start-up-interviews": "",
  "gnav.interview.supporter": "Supporter Interviews",
  "gnav.interview.serial-column": "",
  "gnav.interview.supporter-column": "",
  "gnav.interview.link-j-staff-blog": "",
  "gnav.interview.linkJStaffBlog": "LINK-J Staff Blog",
  "gnav.interview.startUpInterviews": "Start-up Interviews",
  "gnav.interview.researcherInterviews": "Researcher Interviews",
  "gnav.news.title": "News",
  "gnav.news.subTitle": "News",
  "gnav.news.topics": "Topics",
  "gnav.news.media": "LINK-J in the News",
  "gnav.news.pressRelease": "Press Releases",
  "gnav.news.newsEvents": "Events",
  "gnav.news.overseas": "News from overseas",
  "gnav.interview.column": "What’s in Nihonbashi",
  "gnav.bulletinboard.title": "The Shared Bulletin Board",
  "gnav.bulletinboard.pressRelease": "Press Releases",
  "gnav.bulletinboard.news": "News & Activities",
  "gnav.bulletinboard.bulletinBoardsRecruit": "Recruitment",
  "gnav.bulletinboard.bulletinBoardsEvent": "Events",
  "gnav.about.title": "About us",
  "gnav.about.greetings": "Message from the Chairman of the Board",
  "gnav.about.why": "Why in Nihonbashi",
  "gnav.about.west": "What’s LINK-J WEST",
  "gnav.about.overseas": "Overseas Collaborations",
  "gnav.about.message": "Messages of Support",
  "gnav.about.supporter": "Supporters",
  "gnav.about.business.company": "Our Activities",
  "gnav.about.business.organization": "Organization",
  "gnav.membership.business.subscription.brochures": "Brochures",
  "gnav.membership.business.subscription.biocommunity":
    "Greater Tokyo Biocommunity",
  "gnav.membership.title": "Special Members",
  "gnav.membership.introductionCorporate": "List of Special Members",
  "gnav.membership.existing": "About Special Membership",
  "gnav.membership.subscription": "Membership Application",
  "gnav.membership.memberMenu": "専用メニューはこちら",
  "gnav.facilities.title": "Facilities",
  "gnav.facilities.about.room": "Lounges and Conference rooms",
  "gnav.facilities.about.office": "Offices and Laboratory",
  "gnav.facilities.facilities": "",
  "gnav.facilities.access": "Access",
  "gnav.youtube.link.title": "YouTube Channel",
  "gnav.youtube.alt": "YouTube channel",
  "gnav.bnr_footer3.alt": "lifescience",
  "gnav.bnr_footer4.alt": "Mitsui Link-Lab",

  "gnav.facilities.link.text": "",
  "gnav.membership.link.text": "",
  "gnav.news.program": "",
  "gnav.news.facilities": "",
  "gnav.news.sponsorship": "",
} as const;
